import Vue from 'vue'

export default new Vue()



// WEBPACK FOOTER //
// ./src/plugins/event-bus.js